import { useListEntityApi } from '@/common/api/listEntityApi';
import type { PackageType } from 'shared/packages/domain/packageType';

export interface ListPackageTypesResponse {
  ok: true;
  packageTypes: PackageType[];
}

export function useListPackageTypes() {
  return useListEntityApi<ListPackageTypesResponse>({
    url: 'packageType',
    translate: (t) => t.packageTypes.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as PackageType[];

      json.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

      return {
        ok: true,
        packageTypes: json,
      };
    },
  });
}
